import { render, staticRenderFns } from "./HorseStatFertilite.vue?vue&type=template&id=b6735b60&"
import script from "./HorseStatFertilite.vue?vue&type=script&lang=js&"
export * from "./HorseStatFertilite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports